import LiteTradeMarketAsset from "../LiteTradeMarketAsset/LiteTradeMarketAsset";
import React, { useEffect } from "react";
import { Virtuoso } from "react-virtuoso";
import { ILiteTradeAssetSymbol } from "../../types/liteTradeReducer.t";
import { addMarketDataCandleWatchAction, removeMarketDataCandleWatchAction } from "../../liteTradeActions";
import { useDispatch, useSelector } from "react-redux";
import { getLiteTradeAssets } from "../../liteTradeSelectors";
import { LiteTradeSearchResultListStyled } from "./styled/LiteTradeSearchResultListStyled";
import useFilteredAssets from './hooks/useFilteredAssets';

interface ILiteTradeSearchResultList {
    onAssetSelect?: (symbol: ILiteTradeAssetSymbol) => void,
    searchValue: string,
}

function LiteTradeSearchResultList(props: ILiteTradeSearchResultList) {
    const { onAssetSelect, searchValue } = props;
    const assets = useSelector(getLiteTradeAssets);
    const dispatch = useDispatch();
    const filteredAssets = useFilteredAssets(assets, searchValue);

    useEffect(() => {
        assets.forEach(asset => {
            dispatch(addMarketDataCandleWatchAction({ fromComponentName: 'lite-trade-search', symbol: asset.symbol }));
        });
        return () => {
            dispatch(removeMarketDataCandleWatchAction({ fromComponentName: 'lite-trade-search' }));
        }
    }, [dispatch, assets]);

    return <LiteTradeSearchResultListStyled>
        <Virtuoso
            increaseViewportBy={400}
            data={filteredAssets}
            itemContent={(index, item) => <LiteTradeMarketAsset
                asset={item}
                key={item.symbol}
                onAssetSelect={onAssetSelect}
                source={'asset-search'}
            />}
            components={{
                Scroller: React.forwardRef((props, ref) => <div ref={ref} {...props}
                                                                className={'custom-scrollbar'}/>),
            }}
        />
    </LiteTradeSearchResultListStyled>
}

export default LiteTradeSearchResultList;

